// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"154":"8f26da03d2fd9972","705":"594836e37be4d808","796":"594836e37be4d808","888":"e9b536a0dbcdb7b1"}[chunkId] + ".css";
};